import { render } from "./ChangeStateForm.vue?vue&type=template&id=71ded18e"
import script from "./ChangeStateForm.vue?vue&type=script&lang=js"
export * from "./ChangeStateForm.vue?vue&type=script&lang=js"

import "./ChangeStateForm.vue?vue&type=style&index=0&id=71ded18e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__